module.exports = __webpack_public_path__ + "static/media/partners.9b4387d4.jpg";